import { BaSeLoadingPage } from '@base/react';
import * as Sebrae from '@sebrae/react-core';
import * as React from 'react';

const MainPage = React.lazy(() => import('./main-page'));

export const Routes = () => (
  <Sebrae.Routes
    routes={[
      {
        routePath: '/',
        pageToRender: (
          <React.Suspense fallback={<BaSeLoadingPage />}>
            <MainPage />
          </React.Suspense>
        ),
      },
    ]}
  />
);
